<div [class.fullcontainer]='!this.isPopup'>
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  <div class='sheet'>
    <h1 class='header'>Create a new site</h1>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-accounts-form [account]='this.account' [isSimpleOrder] = 'this.isSimpleOrder'></app-accounts-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" (click)='this.cancel()'>Cancel</button>
    </form>
  </div>
</div>
